import React from "react";
import Title from "../../../components/title/Title";

const GeneralStatistics = () => {

    return (
        <React.Fragment>
            <Title title="Statistik :: Allgemein" />
        </React.Fragment>
    )
};

export default GeneralStatistics;